/** Node for checkbox item */
export class CheckboxItemNode {
    children?: CheckboxItemNode[];
    item?: string;
    name?: string;
    id?: string;
    indeterminate?: boolean;
    checked?: boolean;
    disabled?: boolean;
    level?: number;
    expandable?: boolean;
    columns?: any[];
}

/** Flat checkbox item node with expandable and level information */
export class CheckboxItemFlatNode {
    id?: string;
    item?: string;
    name?: string;
    level?: number;
    expandable?: boolean;
    children?: CheckboxItemFlatNode[];
    checked?: boolean;
    disabled?: boolean;
    columns?: any[];
}